export default __webpack_public_path__ + "9234751ae60cf2742d1ecfc6df2f2311.png";